import React from "react";
import { energyConcepts } from "../data/siteData";
import { images } from "../data/images";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./About.css";

export default function About() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".about__statement span"), {
      y: 40,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "power3.out",
      scrollTrigger: { trigger: el.querySelector(".about__statement"), start: "top 85%" },
    });

    gsap.from(el.querySelectorAll(".about__concept"), {
      ...revealUp(null, el.querySelector(".about__concepts")),
      stagger: 0.1,
    });

    gsap.from(el.querySelector(".about__narrative-image"), revealUp(null, el.querySelector(".about__narrative")));
    gsap.from(
      el.querySelector(".about__narrative-text"),
      revealUp(null, el.querySelector(".about__narrative"), { delay: 0.15 })
    );

    gsap.to(el.querySelector(".about__narrative-image"), {
      backgroundPosition: "center 65%",
      ease: "none",
      scrollTrigger: {
        trigger: el.querySelector(".about__narrative"),
        start: "top bottom",
        end: "bottom top",
        scrub: 0.6,
      },
    });
  }, []);

  return (
    <section id="energy" className="about section" ref={sectionRef}>
      <div className="about__grid-bg" aria-hidden="true" />
      <div className="container">
        <span className="eyebrow">The Energy Of Selectra</span>
        <h2 className="about__statement">
          <span>ENERGY SHOULD</span>
          <span className="accent-text">DO MORE.</span>
        </h2>

        <div className="about__concepts">
          {energyConcepts.map((c) => (
            <div className="about__concept" key={c.number}>
              <span className="about__concept-number">{c.number}</span>
              <h3 className="about__concept-title">{c.title}</h3>
              <p className="about__concept-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="about__narrative">
          <div
            className="about__narrative-image"
            style={{ backgroundImage: `url(${images.teamMeeting})` }}
          />
          <div className="about__narrative-text">
            <span className="eyebrow">Who We Are</span>
            <h2 className="about__narrative-title">
              INTELLIGENT SOLUTIONS
              <br />
              FOR <span className="accent-text">SMART INFRASTRUCTURE.</span>
            </h2>
            <p>
              Selectra Technologies is a professional firm specialising in
              intelligent solutions for smart infrastructure. We started
              operations with the primary objective of offering services
              ranging from Renewable Energy Solutions, Power Backup
              Solutions, and Intelligent Battery Monitoring Solutions
              (iBMUs), among others.
            </p>
            <p>
              We are a committed organisation working towards building
              long-term relationships with our customers and offering value
              through a combination of quality and price. Our in-depth
              understanding of technology and hands-on experience helps us
              bring the best technical practices to deliver world-class
              quality of service and maximise performance.
            </p>
            <p>
              Our team is made up of professionals who aim to protect the
              environment with the latest technologies, while offering
              immediate and long-term savings to every consumer we work
              with.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
